// DATAMODEL-01: única fuente de verdad para mapas slug→label de
// los enums del listing. Se derivan en build time desde
// configListing.js para evitar duplicación en cards y panels.

import { listingFields } from '../config/configListing';

const buildLabelMap = (key, { includeSuboptions = false } = {}) => {
  const field = listingFields.find(f => f.key === key);
  const map = {};
  (field?.enumOptions || []).forEach(opt => {
    map[opt.option] = opt.label;
    if (includeSuboptions && Array.isArray(opt.suboptions)) {
      opt.suboptions.forEach(sub => {
        map[sub.option] = sub.label;
      });
    }
  });
  return map;
};

// Sector incluye las 11 opciones madre + 55 subsectores como flat map.
export const SECTOR_LABELS = buildLabelMap('sector', { includeSuboptions: true });

// Facturación: 10 tramos.
export const FACTURACION_LABELS = buildLabelMap('facturacion');

// Modalidad: 3 opciones.
export const MODALIDAD_LABELS = buildLabelMap('modalidad');

// Provincia: 52 opciones.
export const PROVINCIA_LABELS = buildLabelMap('provincia');

// Tipo de operación: 2 opciones.
export const TIPO_OPERACION_LABELS = buildLabelMap('tipo_operacion');

// Antigüedad: 5 opciones.
export const ANTIGUEDAD_LABELS = buildLabelMap('antiguedad');

/**
 * FASE2-COPY-01 — Etiquetas propias de un campo, cuando la misma opción se
 * lee distinta según de qué lado del mercado se mire.
 *
 * `tipo_operacion` (venta) y `tiposOperacion` (compra) comparten el MISMO
 * array de opciones, que es lo que hace que los dos anuncios se puedan cruzar.
 * Pero sus etiquetas describen lo que hace el vendedor —"Venta total"— y no
 * dicen nada al comprador, que lo que quiere es "Compra del negocio completo".
 *
 * EL SLUG NO CAMBIA. Solo se sustituye el texto visible: `venta-total` sigue
 * siendo `venta-total` en publicData y en el search schema, que es lo que
 * permite que un mandato case con un anuncio de venta.
 *
 * Convención de clave: `ListingFields.<clave del campo>.<slug>`. La clave del
 * campo ya distingue los dos lados —`tiposOperacion` solo existe en el
 * mandato—, así que no hace falta meter el listing type en la clave.
 *
 * @param {string} fieldKey clave del listing field
 * @param {Array} enumOptions opciones del field config
 * @param {Object} intl
 * @returns {Array} las opciones con el label traducido donde exista
 */
export const localizeEnumOptions = (fieldKey, enumOptions = [], intl) =>
  enumOptions.map(o => {
    const id = `ListingFields.${fieldKey}.${o.option}`;
    // Se consulta el diccionario en vez de formatMessage con defaultMessage
    // para no llenar la consola de "missing message" en los campos que no
    // necesitan etiqueta propia, que son la mayoría.
    const translated = intl?.messages?.[id];
    return translated ? { ...o, label: translated } : o;
  });
